module.exports = __webpack_public_path__ + "bcde547688f080880c847d51fd668fb9.svg";